$(document).ready(function () {
  let selectorBox = $(".template-page-nhc-qualia-mind-attention .get-started-cta-box");
  var prevScrollTop = $(window).scrollTop();
    $(window).on('scroll', function(e) {
        // Variable declaration for search container
        var $src = $(selectorBox);
        var currentScrollTop = $(this).scrollTop()

        if (currentScrollTop >= prevScrollTop && currentScrollTop >= 3000) {
            $src.css({
                'position': 'fixed'
            });
            $(selectorBox).slideDown();
        } else {
            $src.css({
                'position': 'static',
            });
            $(selectorBox).hide();
        }

        prevScrollTop = currentScrollTop
    });
});